import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap} from 'rxjs/operators';
import { ActionTypes } from '@appStore/account/actions';
import * as actions from '@appStore/account/actions';
import { SettingsService } from '@appStore/account/services/settings.service';


@Injectable()
export class FilterViewSettingsEffects {
  constructor(
    private settingsService: SettingsService,
    private actions$: Actions
  ) {}

  loadMyFilterExpandedSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.AnalyzeFilterViewSettingLoad),
      exhaustMap((action) => {
        return this.settingsService.getMyAnalyzeFilterViewSettings().pipe(
          map((settings) => new actions.AnalyzeFilterViewSettingLoadSuccess(settings)),
          catchError((error) => of(new actions.AnalyzeFilterViewSettingLoadFail(error)))
        );
      })
    );
  });
  
  updateFilterExpandedSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.AnalyzeFilterViewSettingUpdate),
      map((action: actions.AnalyzeFilterViewSettingUpdate) => action.payload),
      exhaustMap((setting) => {
        return this.settingsService.updateAnalyzeFilterViewSetting(setting).pipe(
          map((retval) => new actions.AnalyzeFilterViewSettingUpdateSuccess(retval)),
          catchError((error) => of(new actions.AnalyzeFilterViewSettingUpdateFail(error)))
        );
      })
    );
  });

}
